// A filter value as a list: arrays drop blanks, a string is one value (never
// split on ',' — retailer/attribute names can contain commas), '' is none.
export const toSelection = (v) => (Array.isArray(v) ? v : v ? [v] : []).filter(Boolean);
